import Marquee from "react-fast-marquee";

const ITEMS = ["LOSLASSEN", "EINFACH GLÜCKLICH", "03.09.2026", "LIVE VIA ZOOM"];

export default function MarqueeBand() {
  return (
    <section data-testid="marquee-band" aria-hidden="true" className="bg-sand py-8 md:py-10 overflow-hidden border-y border-line/60">
      <Marquee speed={26} gradient={false} pauseOnHover={false}>
        {[...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
          <span key={i} className="mx-8 md:mx-12 flex items-center font-serif tracking-[0.14em] text-2xl md:text-4xl text-bronze/45">
            {t}
            <span className="ml-16 md:ml-24 text-gold/70 text-xl md:text-2xl">—</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
